import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const BillingDetails = () => {
    return (
        <><PatientAction />
        <form>
            <div className="Billing-info" >
                <div className="mt-3 ml-4"> <h4>Billing Information</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0 }}>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Self</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Self" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Company</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Company" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Insurance</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Insurance" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default BillingDetails; 